import { render, staticRenderFns } from "./ModelText.vue?vue&type=template&id=43d1b16c&scoped=true"
import script from "./ModelText.vue?vue&type=script&lang=js"
export * from "./ModelText.vue?vue&type=script&lang=js"
import style0 from "./ModelText.vue?vue&type=style&index=0&id=43d1b16c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d1b16c",
  null
  
)

export default component.exports